import script from "./DesciptionItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesciptionItem.vue?vue&type=script&lang=ts&setup=true"

import "./DesciptionItem.vue?vue&type=style&index=0&id=26ce3eca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ce3eca"]])

export default __exports__